import { esc } from './render.js'

// The popover shown when a matchup with more than one game is clicked. Lives in the viewport
// (not the canvas) so it is unaffected by zoom.
export function makeSeriesPopover(viewportEl, { manager = false } = {}) {
  let popover = null

  function close() {
    if (popover) { popover.remove(); popover = null }
  }

  function gameRow(g, matchup) {
    const aw = g.winner_id != null && g.away && g.winner_id === g.away.id
    const hw = g.winner_id != null && g.home && g.winner_id === g.home.id
    const score = g.recorded
      ? `${aw ? '<b>' : ''}${esc(g.away.name)} ${g.away_score}${aw ? '</b>' : ''} @ ${hw ? '<b>' : ''}${esc(g.home.name)} ${g.home_score}${hw ? '</b>' : ''}`
      : `<span class="c-tournament-bracket_pop-muted">${esc(g.away.name)} @ ${esc(g.home.name)}${g.schedule ? ' · ' + esc(g.schedule) : ''}</span>`
    const link = manager && g.admin_url
      ? `<a href="${esc(g.admin_url)}" data-js-no-pan>${g.recorded ? 'Edit' : 'Score'}</a>`
      : `<a href="${esc(g.url)}" data-js-no-pan>Game page</a>`
    return `<div class="c-tournament-bracket_pop-game"><span class="c-tournament-bracket_pop-label">${esc(g.label)}</span><span class="c-tournament-bracket_pop-score">${score}</span>${link}</div>`
  }

  function open(matchup, anchor) {
    close()
    const rows = matchup.games.map(g => gameRow(g, matchup))
    const decided = ['complete', 'walkover', 'skipped', 'override'].includes(matchup.status)
    if (!decided) {
      for (let i = matchup.games.length; i < matchup.best_of; i++) {
        rows.push(`<div class="c-tournament-bracket_pop-game"><span class="c-tournament-bracket_pop-label">Game ${i + 1}</span><span class="c-tournament-bracket_pop-muted">Not scheduled</span><span></span></div>`)
      }
    }
    const title = matchup.best_of > 1
      ? `${matchup.key} · Best of ${matchup.best_of} · ${matchup.top.wins}–${matchup.bottom.wins}`
      : `${matchup.key}`
    popover = document.createElement('div')
    popover.className = 'c-tournament-bracket_popover'
    popover.setAttribute('data-js-popover', '')
    popover.setAttribute('data-js-no-pan', '')
    popover.innerHTML = `<div class="c-tournament-bracket_pop-head"><span>${esc(title)}</span><button type="button" class="c-tournament-bracket_pop-close" data-js-pop-close aria-label="Close">×</button></div>${rows.join('')}`
    viewportEl.appendChild(popover)
    const vr = viewportEl.getBoundingClientRect(), br = anchor.getBoundingClientRect()
    let left = br.left - vr.left
    let top = br.bottom - vr.top + 8
    left = Math.max(8, Math.min(left, vr.width - popover.offsetWidth - 8))
    if (top + popover.offsetHeight > vr.height - 8) top = br.top - vr.top - popover.offsetHeight - 8
    popover.style.left = left + 'px'
    popover.style.top = Math.max(8, top) + 'px'
  }

  viewportEl.addEventListener('click', e => {
    if (e.target.closest('[data-js-pop-close]')) { close(); return }
    if (!e.target.closest('[data-js-popover]') && !e.target.closest('[data-js-open-matchup]')) close()
  })
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close() })

  return { open, close }
}
